import React from "react";
import { SFStack } from "../grid";
import SFTypography from "../typography";
import SFTooltip from "../tooltip";
import getStyled from "../../hooks/getStyled";
import { SFDowngradeIcon, SFTrendingFlat, SFUpgradeIcon } from "../icons";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

const { styled } = getStyled();

const VARIANTS = { light: "light", dark: "dark" };

const SkillProgress = {
  UP: "Up",
  DOWN: "Down",
  STATIC: "Static",
  NEW: "New",
};

const SkillIcon = ({ skill }) => {
  if (skill.progress === SkillProgress.UP) {
    return <SFUpgradeIcon />;
  } else if (skill.progress === SkillProgress.DOWN) {
    return <SFDowngradeIcon />;
  } else if (skill.progress === SkillProgress.STATIC) {
    return <SFTrendingFlat />;
  }
  return null;
};

const SkillRank = styled("span")(({ theme, variant }) => ({
  marginLeft: "16px",
}));

const RankContainer = styled("div")(({ theme, variant }) => ({
  width: 56,
  height: 56,
  backgroundColor:
    variant == VARIANTS.light
      ? theme.palette.grey50.main
      : theme.palette.grey200.main,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "nowrap",
  borderRadius: "4px",
  position: "relative",
  ".MuiSvgIcon-root": {
    fontSize: "16px",
  },
  fontSize: 6,
  [theme.breakpoints.between("md", "lg")]: {
    fontSize: 6,
  },
  [theme.breakpoints.only("xs")]: {
    fontSize: 6,
  },
}));

const SkillContainer = styled("div")(({ theme }) => ({
  whiteSpace: "nowrap",
  alignItems: "center",
  display: "flex",
}));

const TrendTooltip = ({ skill, tooltipRanking, tooltipQuarter }) => (
  <SFTooltip
    content={
      <SFTypography variant="body2">
        <SFTypography variant="bold">{`${skill.name} `}</SFTypography>
        {tooltipRanking} {tooltipQuarter}
      </SFTypography>
    }
    width="narrow"
  >
    <RankContainer>
      <SkillContainer>
        <SkillRank>
          <SFTypography variant="h1" forceComponent="div">
            {skill.rank}
          </SFTypography>
        </SkillRank>
        <SkillIcon skill={skill} />
      </SkillContainer>
    </RankContainer>
  </SFTooltip>
);

const BoxStyled = styled(Button)(({ theme, variant }) => ({
  border: `1px solid ${theme.palette.grey225.main}`,
  borderRadius: "4px",
  padding: 12,
  backgroundColor: variant == VARIANTS.light ? "white" : "#FAFAFC",
  //cursor: "pointer",
  width: "100%",
  display: "flex",
  justifyContent: "flex-start",
}));

const SFTrendingSkillCard = ({
  variant,
  skill,
  tooltipRanking,
  tooltipQuarter,
  onClick,
}) => {
  return (
    <BoxStyled variant={variant} onClick={onClick} aria-label={skill.name}>
      <SFStack
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={2}
      >
        <TrendTooltip
          skill={skill}
          tooltipRanking={tooltipRanking}
          tooltipQuarter={tooltipQuarter}
        />
        <SFStack alignItems="flex-start">
          <SFTypography align="left" variant="body2bold" color="grey400">
            {skill.name}
          </SFTypography>
          <SFTypography variant="body2">{skill.category}</SFTypography>
        </SFStack>
      </SFStack>
    </BoxStyled>
  );
};

export default SFTrendingSkillCard;

SFTrendingSkillCard.propTypes = {
  skill: PropTypes.shape({
    name: PropTypes.string,
    category: PropTypes.string,
    rank: PropTypes.number,
    progress: PropTypes.oneOf(Object.values(SkillProgress)),
  }),
  tooltipRanking: PropTypes.object,
  tooltipQuarter: PropTypes.object,
  onClick: PropTypes.func,
};
